import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import DeleteForeverTwoTone from "@material-ui/icons/DeleteForeverTwoTone";
import StarBorderTwoTone from "@material-ui/icons/StarBorderTwoTone";
import React, { useState } from "react";
import readFile from "../../../utils/readFile";

const ActivePhoto = ({photo, photos, handlerMarkMain, handlerRemove}) => {
  const [file, setFile] = useState<string>("");
  
  if (photo.file instanceof File) {
    readFile(photo.file).then(setFile);
  } else if (typeof photo.file === "string") {
    setFile(photo.file);
  }
  
  return (
    <Box
      sx={{
        "& img": {
          width: "100%",
        },
        margin: "auto",
        maxWidth: 300,
        minHeight: 150,
        textAlign: "center",
        position: "relative",
      }}
    >
      <img src={file} srcSet={file} />
      <Box sx={{ position: "absolute", top: 0, right: 0 }}>
        <Tooltip
          title={!photo?.isMain ? "Сделать основным" : "Основное изображение"}
        >
          <span>
            <IconButton
              sx={{ color: "gold" }}
              size={"small"}
              onClick={() => handlerMarkMain(photo.index)}
              disabled={photos.length <= 1 || !!photo?.isMain}
            >
              <StarBorderTwoTone />
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip title={"Удалить изображение"}>
          <span>
            <IconButton
              color={"error"}
              size={"small"}
              onClick={() => handlerRemove(photo.index)}
              disabled={photos.length <= 1}
            >
              <DeleteForeverTwoTone />
            </IconButton>
          </span>
        </Tooltip>
      </Box>
    </Box>
  );
}

export default ActivePhoto